
import {
  Vue,
  Component,
  Mixins,
} from 'vue-property-decorator';
import {
  Steps,
  Step,
} from 'element-ui';
import BScroll from 'better-scroll';
import { Mutation, State } from 'vuex-class';
import Util from '@/libs/util';
import pageMixin from '@/views/Home/mixins/pageMixin';
import BSMixin from '@/views/Home/mixins/bsMixin';
import { IFileCheck, IQuesSearch } from '@/types/question.d';
import { IModalConf } from '@/components/Modal/index.d';
import tModal from '@/components/Modal/index.vue';
import api from '@/api/question';
import courseApi from '@/api/course';
import tButton from '@/components/Button/tButton.vue';
import { ITButton, IBadge } from '@/components/Button/index.d';
import { tSearch } from '@/components/Search/index';
import First from './components/firstStep.vue';
import Second from './components/secondStep.vue';
import Third from './components/thirdStep.vue';
import List from './components/list.vue';
import noRemove from './components/noRemove.vue';
import Edit from './components/edit.vue';
import SearchForm from './components/searchForm.vue';

@Component({
  components: {
    tModal,
    tButton,
    Steps,
    Step,
    tSearch,
    First,
    Second,
    Third,
    List,
    noRemove,
    Edit,
    SearchForm,
  },
})

export default class ManageView extends Mixins(pageMixin, BSMixin) {
  @Mutation('questions/SET_ASSET_MANAGE_REMOVE_DATA') setRemoveDatas!: Function;

  @Mutation('questions/SET_ASSET_MANAGE_REMOVE_FLAG') setRemoveFlag!: Function;

  @State((state => state.questions.manage.removeData)) removeDatas!: any;

  @State((state => state.questions.manage.removeFlag)) removeFlag!: boolean;

  private inputShow: boolean = true;

  private UploadBtn: ITButton = {
    title: '上 传',
    type: 'primary',
    icon: 'cloud-upload',
    callback: () => this.$refs.upload.click(),
  };

  private allotBtn: ITButton = {
    title: '分 配',
    type: 'primary',
    icon: 'share-square-o',
    disabled: true,
    callback: () => this.handleAllotBtn(),
  };

  private removeBtn: ITButton = {
    title: '删 除',
    type: 'primary',
    icon: 'trash-o',
    disabled: true,
    callback: () => this.handleRemoveBtn(),
  }

  private allotBadge: IBadge = {
    show: 1,
    value: 0,
    max: 99,
  }

  private nextBtn: ITButton = {
    title: '下一步',
    type: 'primary',
    callback: () => this.handleNextClick(),
  };

  private modalConf: IModalConf = {
    title: '题库上传',
    show: false,
    close: () => this.handleModalConf(),
  };

  private lookConf: IModalConf = {
    title: '',
    show: false,
    close: () => this.handleLookConf(),
  };

  private selectQues: Array<any> = [];

  private steps: Array<{ title: string, icon: string }> = [
    {
      title: '选择图片',
      icon: 'el-icon-star-off',
    },
    {
      title: '选择类型',
      icon: 'el-icon-notebook-1',
    },
    {
      title: '拖动排序',
      icon: 'el-icon-sort',
    },
  ];

  private loading: { [key: string]: boolean } = { modal: false, next: false };

  private files: FileList | [] = [];

  private curModalComp: string = 'First';

  private preFiles: Array<IFileCheck> = [];

  private cid: string = ''; // 章节id

  private nameReg: RegExp = /^(单选题|多选题)[_][^_]+[_]([0-9]|([0-9][,])+[0-9])[_][1-9]$/;

  private answer: string = '';

  private src: string = '';

  private noRvisible: boolean = false;

  private noRemove: { [key: string]: string } = {};

  private editVisible: boolean = false;

  private editForm: object = {};

  private searchForm: { [key: string]: string } = {};

  private searchTitle: string = '';

  public $refs!: {
    upload: HTMLInputElement,
    modalBody: HTMLElement,
    stepComp: First | Second,
    list: List,
    searchForm: SearchForm;
  };

  get stepActive() {
    /* eslint-disable default-case */
    switch (this.curModalComp) {
      case 'First': return 1;
      case 'Second': return 2;
      case 'Third': return 3;
    }
    return 1;
  }

  mounted() {
    this.initRmoveModalEvent();
  }

  initRmoveModalEvent() {
    if (this.removeFlag && this.removeDatas.length > 0) {
      this.noRvisible = true;
      this.noRemove = this.removeDatas;
    }
  }

  /**
   * @author liangyongmou
   * @description 打开修改模态框
   */
  handleUpdate(obj: object) {
    this.editForm = obj;
    this.editVisible = true;
  }

  /**
   * @author Terry
   * @description 处理图片预览
   */
  handleCoverPreview(item: { [key: string]: any }) {
    this.answer = '';
    this.lookConf.show = true;
    this.lookConf.title = item.name;
    this.src = item.imgUrl;
    item.object.answer.forEach((ele: any) => {
      this.answer = `${this.answer} ${String.fromCharCode(Number(ele) + 64)}`;
    });
  }

  /**
   * @author liangyongmou
   * @description 查看关闭事件
   */
  handleLookConf() {
    this.lookConf.show = false;
  }

  /**
   * @author liangyongmou
   * @description 搜素词改变事件
   */
  handleSearchChange(v: string) {
    this.allotBadge.value = 0;
    this.getData({ tt: v });
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索改变
   * @param { any } form 搜索值
   */
  handleSearchFormChange(form: IQuesSearch) {
    /* eslint-disable prefer-destructuring */
    this.searchForm.tp = form.courseType[1];
    this.searchForm.cs = form.courseStep[1];
    this.searchForm.tt = form.title;
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索提交事件
   */
  handleAdvancedSearch() {
    const form: any = this.$refs.searchForm.getFormData();
    const params: any = {
      tt: form.title,
      tp: form.courseType[1] || '',
      cs: form.courseStep[1] || '',
    };
    const flag: boolean = Object.values(params).some((em: any) => em && em.length > 0);
    if (flag) this.getData(params);
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索普通搜索切换事件
   * @param { boolean } activate 是否切换
   */
  handleActivateChange(activate: boolean) {
    if (activate) {
      this.$refs.searchForm.setTitle(this.searchTitle);
      this.searchTitle = '';
    } else this.searchTitle = this.$refs.searchForm.getFormData().title;
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索清空按钮事件
   */
  handleAdvanceClear() {
    this.$refs.searchForm.handleClear();
    this.getData();
  }

  /**
   * @author Terry
   * @description 处理分配事件
   */
  handleAllotBtn() {
    this.preFiles = this.$refs.list.getSelectList();
    this.modalConf.title = '题库分配';
    this.handleOpenModal();
    this.loading.modal = false;
  }

  /**
   * @author liangyongmou
   * @description 打开上传事件
   */
  handleOpenModal() {
    this.loading.modal = true;
    this.modalConf.show = true;
    this.curModalComp = 'First';
    this.nextBtn.title = '下一步';
    this.loading.next = false;
    this.inputShow = false;
  }

  /**
   * @author liangyongmou
   * @description 查看模态框关闭事件
   */
  handleModalConf() {
    this.modalConf.show = false;
    this.inputShow = true;
    if (this.curModalComp === 'Third' && this.modalConf.title.includes('上传')) this.$refs.list.getData(true);
  }

  /**
   * @author liangyongmou
   * @description 下一步点击事件
   */
  handleNextClick() {
    this.loading.next = true;
    /* eslint-disable default-case */
    switch (this.curModalComp) {
      case 'First': this.handleFirstSubmit(); break;
      case 'Second': this.handleSecondSubmit(); break;
      case 'Third': this.handleThirdSubmit(); break;
    }
  }

  /**
   * @author liangyongmou
   * @description 排序提交事件
   */
  handleThirdSubmit() {
    this.loading.modal = true;
    /* eslint-disable max-len */
    api.setChapterQuestions({ cid: this.cid, ids: (this.$refs.stepComp as Third).getSort() }).then((res: any) => {
      this.loading.next = false;
      this.loading.modal = false;
      this.modalConf.show = false;
      this.getData();
    }).catch(() => {
      this.loading.next = false;
      this.loading.modal = false;
    });
  }

  /**
   * @author liangyongmou
   * @description 选择类型提交事件
   */
  handleSecondSubmit() {
    (this.$refs.stepComp as Second).handleNext().then((res: any) => {
      if (res && res.tid && res.cid) {
        this.loading.modal = true;
        this.cid = res.cid;
        const promise: Array<Promise<any>> = [];
        this.preFiles.filter((em: any) => em.file).forEach((em: IFileCheck) => {
          if (em.status === 'success') {
            const data: FormData = new FormData();
            data.append('file', em.file as File);
            data.append('md5', em.md5 || '');
            data.append('ext', em.ext || '');
            data.append('name', em.name);
            data.append('tid', res.tid);
            promise.push(api.uploadQuestionFiles(data));
          }
        });
        Promise.all(promise).then((results: any) => {
          /* eslint-disable no-param-reassign */
          this.preFiles.forEach((preFile: IFileCheck) => {
            results.forEach((result: any) => {
              if (result.data.md5 === preFile.md5) preFile.pid = result.data.pid;
            });
          });
          courseApi.getQlist(res.cid).then((ques: any) => {
            const ids: Array<string> = this.preFiles.map((file: IFileCheck) => file.pid || '');
            /* eslint-disable curly */
            if (ques && ques.length > 0) {
              ques.forEach((que: any) => {
                if (!ids.includes(que.id)) {
                  this.preFiles.push({
                    pid: que.id,
                    sort: que.qstSort,
                    name: que.title,
                    imgUrl: que.context,
                    status: 'success',
                    errors: [],
                  });
                }
              });
            }
            this.loading.modal = false;
            this.loading.next = false;
            this.curModalComp = 'Third';
            this.nextBtn.title = '提 交';
          }).catch(() => {
            this.loading.modal = false;
            this.loading.next = false;
          });
        /* eslint-disable no-return-assign */
        }).catch(() => {
          this.loading.modal = false;
          this.loading.next = false;
        });
      } else {
        this.loading.next = false;
      }
    });
  }

  /**
   * @author liangyongmou
   * @description 选择图片提交事件
   */
  handleFirstSubmit() {
    const nameErrors: Array<any> = this.preFiles.filter((em: IFileCheck) => em.status === 'nameError');
    if (nameErrors.length > 0) {
      this.msg('请按提示修改后在继续操作呦 ~', 'warning');
      this.loading.next = false;
    } else {
      this.curModalComp = 'Second';
      this.loading.next = false;
    }
  }

  /**
   * @author liangyongmou
   * @description 图片选择事件
   * @param { number } total 选择数
   */
  handleAllotVis(total: number) {
    this.allotBtn.disabled = !(total > 0);
    this.removeBtn.disabled = !(total > 0);
    this.allotBadge.value = total;
  }

  /**
   * @author Terry
   * @description 名字改变事件
   * @param { string, string } data
   */
  handleNameChange(data: { md5: string, value: string }) {
    /* eslint-disable no-param-reassign */
    this.preFiles.forEach((em: IFileCheck) => {
      em.name = data.value;
      if (em.md5 === data.md5 && em.errors.length > 0 && this.nameReg.test(data.value)) {
        const nums: Array<any> = data.value.split('_');
        if (parseInt(nums[2], 10) > parseInt(nums[3], 10)) {
          em.errors.push({
            type: 'InputError',
            msg: '正确选项不在选项总数之内 ~ ',
          });
          em.status = 'nameError';
          em.errors = em.errors.filter((error: { type: string, msg: string }) => error.type !== 'nameError');
        } else {
          em.errors = em.errors.filter((error: { type: string, msg: string }) => error.type !== 'InputError');
          em.status = 'success';
        }
      } else if (em.md5 === data.md5 && em.errors.length > 0 && !this.nameReg.test(data.value)) {
        em.status = 'nameError';
      }
    });
  }

  /**
   * @author Terry
   * @description 处理上传事件
   */
  async handleUpload() {
    this.preFiles = [];
    this.files = this.$refs.upload.files as FileList;
    this.handleOpenModal();
    this.handleFileKListCheck(Array.from(this.files)).then((res: any) => {
      const md5s: Array<string> = [];
      res.forEach((em: IFileCheck, index: number) => {
        /* eslint-disable no-param-reassign */
        if (!md5s.includes(em.md5 || '')) md5s.push(em.md5 || '');
        else res[index] = null;
      });
      res = res.filter((ele: any) => ele);
      if (md5s.length === 0) return;
      api.checkQuestionMd5(md5s).then((result: any) => {
        res.forEach((em: IFileCheck) => {
          result.data.forEach((item: { md5: string, name: string, pid: string }) => {
            if (em.md5 === item.md5) {
              em.status = 'md5Exist';
              em.name = item.name;
              em.pid = item.pid;
            }
          });
        });
        /* eslint-disable no-confusing-arrow */
        this.preFiles = res.filter((em: IFileCheck) => !(em.status === 'md5Repeat'))
          .sort((a: IFileCheck, b: IFileCheck) => a.status > b.status ? 1 : -1);
        this.loading.modal = false;
      /* eslint-disable no-return-assign */
      }).catch(() => {
        this.modalConf.show = false;
        this.loading.modal = false;
      });
    });
  }

  /**
   * @author Terry
   * @description 处理文件检测
   * @param { File } file
   * @returns { Promise<IFileCheck> }
   */
  /* eslint-disable class-methods-use-this */
  handleFileCheck(file: File): Promise<IFileCheck> {
    const extReg: RegExp = /\.\w+$/;
    return new Promise(async (resolve, reject) => {
      /* eslint-disable object-curly-newline */
      const item: IFileCheck = { name: file.name.replace(/(.*\/)*([^.]+).*/ig, '$2'), errors: [], file, status: 'success', sort: 0 };
      item.md5 = await Util.compFileMd5(file);
      const result: any = Array.from(extReg.exec(file.name) || []);
      item.ext = result.length > 0 ? result[0] : '';
      if (!this.nameReg.test(item.name)) {
        item.errors.push({
          type: 'nameError',
          msg: '文件名命名格式有误 ~ ',
        });
        item.status = 'nameError';
      } else {
        const nums: Array<any> = item.name.split('_');
        if (parseInt(nums[2], 10) > parseInt(nums[3], 10)) {
          item.errors.push({
            type: 'InputError',
            msg: '正确选项不在选项总数之内 ~ ',
          });
          item.status = 'nameError';
        }
      }
      resolve(item);
    });
  }

  getData(params?: any) {
    this.allotBtn.disabled = true;
    this.removeBtn.disabled = true;
    this.allotBadge.value = 0;
    this.$refs.list.getData(true, params);
  }

  /**
   * @author Terry
   * @description 处理所有文件检测的返回结果
   * @param { File[] } files
   */
  handleFileKListCheck(files: File[]) {
    const promises: Array<Promise<IFileCheck>> = [];
    for (let i = 0; i < files.length; i += 1) promises.push(this.handleFileCheck(files[i]));
    return Promise.all(promises);
  }

  /**
   * @author liangyongmou
   * @description 删除事件
   */
  handleRemoveBtn() {
    const ids: Array<string> = [];
    const selected = this.$refs.list.getSelectList;
    this.$refs.list.getSelectList().forEach((ele: any) => {
      ids.push(ele.pid);
    });
    this.confirm(`此操作将删除 ${ids.length} 个练习题, 是否继续?`, {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeQues(ids).then((res: any) => {
        this.getData();
        this.allotBtn.disabled = true;
        this.removeBtn.disabled = true;
        close();
        if (res.status) {
          this.noRvisible = true;
          this.noRemove = res.data;
          this.setRemoveDatas(res.data);
          this.setRemoveFlag(true);
        }
        this.$log({
          title: '题库管理 - 删除 - 确定',
          component: 'trial/manage/bModal',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '题库管理 - 删除 - 取消',
      component: 'trial/manage/bModal',
    }));
  }

  hanleRemoveClsoe() {
    this.noRvisible = false;
    this.setRemoveFlag(false);
  }
}
